var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8334C16.6667 15 13.75 17.0834 10.2833 18.2917C10.1018 18.3532 9.90461 18.3503 9.72499 18.2834C6.24999 17.0834 3.33333 15 3.33333 10.8334V5.00003C3.33333 4.77902 3.42113 4.56705 3.57741 4.41077C3.73369 4.25449 3.94565 4.1667 4.16666 4.1667C5.83333 4.1667 7.91666 3.1667 9.36666 1.90003C9.54321 1.74919 9.76779 1.66632 9.99999 1.66632C10.2322 1.66632 10.4568 1.74919 10.6333 1.90003C12.0917 3.17503 14.1667 4.1667 15.8333 4.1667C16.0543 4.1667 16.2663 4.25449 16.4226 4.41077C16.5789 4.56705 16.6667 4.77902 16.6667 5.00003V10.8334Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66669V10",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333H10.0083",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/IconShield.f6a3d206eeab49a9b785bb0c81d3e5b8.svg";
export { ForwardRef as ReactComponent };